import React, { useEffect } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import AccountDetails from './AccountDetails';
import KycDetailsUpload from './KycDetailsUpload';
import './onboarding.css';
import PaymentSetup from './PaymentSetup';
import AgreementsESignatures from './Agreements';
import PropTypes from 'prop-types';
import { getLocalStorageItem, setLocalStorageItem } from '../../services/StorageService';
import AdditionalInformation from './AdditionalDetails';
import { IconButton, Paper, Tooltip, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
function getSteps() {
  return ['Account Details', 'Additional Details', 'KYC Verification Details', 'Payment Setup', 'Agreement & E-Signatures'];
}

export default function UserOnboarding(props) {
    const { isViewUserRequest, close } = props;
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();
    
    useEffect(() => {
        const storedActiveStep = getLocalStorageItem('activeStep');
        if (storedActiveStep) {
            setActiveStep(Number.parseInt(storedActiveStep, 10));
        }
    }, []);

    useEffect(() => {
        return () => {
            if (isViewUserRequest) {
                setLocalStorageItem('activeStep', 0);
            }
        }
    }, []);
    
    useEffect(() => {
        setLocalStorageItem('activeStep', activeStep);
    }, [activeStep]);

    const handleNext = () => {
        const newActiveStep = activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };
    

    return (
        <main className={isViewUserRequest ? 'view-user-request' : ''}>
            <div className="main__container">
                <div className='flexDataTable'>
                    {isViewUserRequest ? <Typography variant="h5" className="mb-4">View User Request</Typography> : <Typography variant="h5" className="mb-4">User Onboarding</Typography>}
                    {isViewUserRequest && (
                        <IconButton className="close-btn" onClick={close}>
                            <Tooltip arrow title="Close" position="top">
                                <CloseIcon />
                            </Tooltip>
                        </IconButton>
                    )}
                </div>
                <Paper className='onboardingFormWrapping fw-3' elevation={2} square>
                    <Stepper nonLinear activeStep={activeStep} style={{ position: 'relative', zIndex: 2, padding: '0' }}>
                        {steps.map((label, index) => (
                            <Step key={label}>
                                <StepButton disabled={!isViewUserRequest} onClick={handleStep(index)} className='stepBtn'>
                                    {label}
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                </Paper>
                <div>
                    {activeStep === 0 && (
                        <AccountDetails {...props} handleBack={handleBack} handleNext={handleNext} activeStep={activeStep} />
                    )}
                    {activeStep === 1 && (
                        <AdditionalInformation {...props} handleBack={handleBack} handleNext={handleNext} activeStep={activeStep} />
                    )}
                    {activeStep === 2 && (
                        <KycDetailsUpload {...props} handleBack={handleBack} handleNext={handleNext} activeStep={activeStep}/>
                    )}
                    {activeStep === 3 && (
                        <PaymentSetup {...props} handleBack={handleBack} handleNext={handleNext} activeStep={activeStep}/>
                    )}
                    {activeStep === 4 && (
                        <AgreementsESignatures {...props} handleBack={handleBack} handleNext={handleNext} activeStep={activeStep} />
                    )}
                </div>
            </div>
        </main>
    );
}

UserOnboarding.propTypes = {
    isViewUserRequest: PropTypes.bool,
    type: PropTypes.string,
    close: PropTypes.func,
}